import Style from "@client/controls/HTML/Style/component";
import { registerGoogleFont } from "@client/lib/fonts";
import { getFontFamilyName } from "@client/lib/settings";
import { STYLE_SHEET_IDS } from "@client/lib/styleSheet";
import { adjustLineHeight } from "@client/lib/text";
import { type GenericMap } from "@client/types";
import { type StyleSheetTextType } from "@client/types/StyleSheet";
import React from "react";
import { getStyleSheetClassName } from "../lib";

type Props = {
  id: string;
  setting: GenericMap<any>;
  type: StyleSheetTextType;
};
export default (props: Props) => {
  registerGoogleFont(props.setting.font);

  const style = React.useMemo(
    () => `
  font-family: ${getFontFamilyName(props.setting.font)}, Helvetica, Arial;
  font-weight: ${props.setting.weight};
  font-size: ${props.setting.size};
  line-height: ${adjustLineHeight(props.setting.line)};
  letter-spacing: ${props.setting.letter};
  font-style: normal;
  text-transform: none;
  text-decoration-color: unset;
  text-decoration-line: unset;
  text-decoration-style: unset;
  text-shadow: none;
`,
    [props.setting]
  );

  const css = React.useMemo(() => {
    const classSelector = `.${getStyleSheetClassName(props.type, props.id)}`;
    if (props.type === "text") {
      if (props.id === STYLE_SHEET_IDS.defaults.text) {
        return `body {${style}}`;
      }

      return `${classSelector} {${style}}`;
    }

    const css = [`${classSelector} ${props.type} {${style}}`];
    if (Object.values(STYLE_SHEET_IDS.defaults).includes(props.id)) {
      css.splice(0, 0, `body ${props.type} {${style}}`);
    }
    return css.reverse().join("\n");
  }, [style, props.id, props.type]);

  return <Style css={css} />;
};
